import React from 'react';
import {withRouter} from 'react-router';
import {withStyles} from "@material-ui/core/styles";
import {Button, Card, CardActionArea, CardActions, CardContent, Typography} from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const styles = {
    cardList: {
        display: "inline-block"
    },
    card: {
        width: 300,
        padding: "10px",
        margin: "15px",
        display: "inline-block"
    },
    title: {
        fontSize: 20
    },
    landingPageRoot: {
        margin: "15px"
    }
};

const makeCard = (title, openLinkMessage, classes, history, targetRoute) => {

    return (
        <Card className={classes.card}>
            <CardActionArea>
                <CardContent>
                    <Typography variant="h5" className={classes.title} color="textSecondary" gutterBottom>{title}</Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary" onClick={() => {history.push(targetRoute)}}> {openLinkMessage}</Button>
            </CardActions>
        </Card>
    );
};

const LandingPage = (props) => {
    const {classes, history} = props;
    const {t} = useTranslation('messages');
    return (
        <div className={classes.landingPageRoot}>
            <div className={classes.cardList}>
                {makeCard(t('landing.playersListTitle'), t('landing.openPlayersList'), classes, history, process.env.REACT_APP_PREFIX + '/players-list')}
                {makeCard(t('landing.registrationTitle'), t('landing.openRegistration'), classes, history, process.env.REACT_APP_PREFIX + '/registration')}
            </div>
        </div>
    );
};

export default withRouter(withStyles(styles)(LandingPage));
